// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"606":"1050c8d8","927":"2b07c392"}[chunkId] + ".chunk.js";
};